import api from './api.service';
import { IEmpresa, ICreateEmpresa, IUpdateEmpresa } from '../types/empresa.types';

export const empresaService = {
  getAll: async (): Promise<{ data: IEmpresa[]; success: boolean }> => {
    const response = await api.get('/empresas');
    return response.data;
  },

  getById: async (id: number): Promise<IEmpresa> => {
    const response = await api.get(`/empresas/${id}`);
    return response.data.data;
  },

  create: async (data: ICreateEmpresa): Promise<IEmpresa> => {
    const response = await api.post('/empresas', data);
    return response.data.data;
  },

  update: async (id: number, data: IUpdateEmpresa): Promise<IEmpresa> => {
    const response = await api.put(`/empresas/${id}`, data);
    return response.data.data;
  },

  softDelete: async (id: number): Promise<void> => {
    await api.delete(`/empresas/${id}`);
  },

  asignarMaestro: async (empresaId: number, usuarioId: number): Promise<void> => {
    await api.post(`/empresas/${empresaId}/asignar-maestro`, { usuarioId });
  },

  uploadLogo: async (id: number, file: File): Promise<{ logoUrl: string }> => {
    const formData = new FormData();
    formData.append('logo', file);
    const response = await api.post(`/empresas/${id}/logo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }
};
